import { useLayoutEffect, useState } from 'react';

/**
 * The shell's mobile bottom slot (`#mobile-bottom-slot` in RootLayout), for route layouts that
 * portal a persistent bottom bar into it on small screens. The slot lives in RootLayout so it
 * can take part in the top-level flex column at the right order, which is impossible from
 * inside `<main>`.
 *
 * State (not a ref) so the element can be read during render. useLayoutEffect runs after the
 * parent has committed, so the slot is guaranteed to exist when the state update fires — lazy
 * useState initialisation and useMemo both run during the render phase, before the parent's
 * DOM is committed, and would return null on the first mount.
 */
export function useMobileBottomSlot(): Element | null {
    const [slot, setSlot] = useState<Element | null>(null);
    useLayoutEffect(() => {
        // Reading a DOM element that only exists after the parent has committed is the primary
        // purpose of useLayoutEffect; the rule suppression is intentional.
        // eslint-disable-next-line react-hooks/set-state-in-effect, react-x/set-state-in-effect
        setSlot(document.getElementById('mobile-bottom-slot'));
    }, []);
    return slot;
}
